import { CalendarDatePickerPreset, presetToValue } from '@diana/core';

export const DEFAULT_TIME_RANGE_PRESET = CalendarDatePickerPreset.LastWeekTime;

export const getDefaultTimeRange = (preset: CalendarDatePickerPreset = DEFAULT_TIME_RANGE_PRESET) => [
  {
    preset,
    value: presetToValue({ preset, timezone: 'UTC' })?.[0] || '',
    displayName: '',
  },
  {
    preset,
    value: presetToValue({ preset, timezone: 'UTC' })?.[1] || '',
    displayName: '',
  },
]; 